export const SUPPORT_EMAIL = "support@treat-it.clinic";
export const SUPPORT_TELEPHONE = "024 7745 0733";
export const SUPPORT_WHATSAPP = "https://wa.me/447385828801";
